export class ContoVO {
  conto: string;
  descrizione: string;
  area: string;
  capienza: number;
  residuo: number;
}
